var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex items-center mb-4"},[_c('label',{staticClass:"w-48"},[_vm._t("label")],2),_c('div',{staticClass:"flex-1"},[_vm._t("input")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }